import React, { useContext } from "react";
import { Button } from "@activehub/common-components-spa-resource";
import { downloadCode, getAccessCodeIsbn } from "../../../network/ApiService";
import { AppContext } from "../../../App";
import "./AccessCodesActionModal.scss";

const DownloadAccessCodes = ({ setLoading, currentRequestId, accessCodeOrderStatus }) => {
    const { ppidTitle,
        setToast,
        translateHTML: tHTML
    } = useContext(AppContext);

    const encodeHTML = (str) => new DOMParser().parseFromString(str, "text/html").documentElement.textContent;

    const toastMessage = ({ title,msg, status }) => {
        setToast({
            title: tHTML(title,{unsafe: true}),
            msg: tHTML(msg, { unsafe: true}),
            styleClass: 'DownloadAccessCodeToast',
            status: status,
            delay: 8000,
            autoHide: true,
            toastImg: `${process.env.PUBLIC_URL}/images/${status === "success" ? "success-green-outline.svg" : "error-red-outline.svg"}`,
            show: true,
        });
    };

    const handleDownload = () => {
        setLoading(true);
        if (currentRequestId) {
            const subscription = downloadCode(currentRequestId).subscribe(
                (response) => {
                    setLoading(false);
                    const today = new Date();
                    const dateStr = today.toISOString().split('T')[0];
                    const blob = new Blob([response], { type: 'text/csv' });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `${encodeHTML(ppidTitle)}_${dateStr}.csv`);
                    document.body.appendChild(link);
                    link.click();
                    link.parentNode.removeChild(link);
                    toastMessage({ 
                        title:'Successfully downloaded', 
                        msg: 'Access codes have been successfully downloaded', 
                        status: 'success' 
                    });
                },
                (error) => {
                    setLoading(false);
                    toastMessage({ 
                        title:'Not downloaded successfully',
                        msg: 'Access codes have not been downloaded. Please try again.', 
                        status: 'error' 
                    });
                }
            );
            return () => subscription.unsubscribe();
        } else {
            setLoading(false);
            console.error('No currentRequestId provided');
        }
    };
    return (
        <div className="download-modal-content">
            <span className="heading">Download selected codes </span>
            <span className="body">
                Download selected access codes. Please note all codes will be valid for 3 years from customer redemption date.
            </span>
            <Button
                className="download-access-codes-btn"
                onClick={() => handleDownload()}
            >
                <span>Download access codes</span>
                <img src={`${process.env.PUBLIC_URL}/images/download-white-v2.svg`} alt="download button" className="download-btn-icon" />
            </Button>
        </div>
    );

}
export default DownloadAccessCodes;